export default __webpack_public_path__ + "static/media/boite12.76e0f093.jpg";